import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { GetSerialNumberCheckResponse } from '../../MyOrders/models/response/getOrderListResponseModel'
import { GetSerialNumberCheck } from '../../MyOrders/models/request/getMyOrderRequest'

export class GetSerialNumberCheckApi extends ClientProxy {
  constructor(props: any) {
    super({
      url: 'MyReports/GetSerialNumberCheck',
      ...props,
    })
  }

  public async checkSerialNumber(request: GetSerialNumberCheck): Promise<GetSerialNumberCheckResponse[]> {
    return await this.postAsync<GetSerialNumberCheckResponse[]>(request)
  }
}
